export default __webpack_public_path__ + "static/media/harvesting.a3823f2b.svg";